var shop_url = "kushalsonline-com.myshopify.com";
var recordedChunks_video = [];
var formData = new FormData();

function markTouchEvent(el, evt) {
  if (evt && evt.type === 'touchend') {
    $(el).data('touchTs', Date.now());
  }
}

function isSyntheticClickAfterTouch(el, evt) {
  if (!evt || evt.type !== 'click') return false;
  const lastTouchTs = Number($(el).data('touchTs') || 0);
  return Date.now() - lastTouchTs < 700;
}

function lockCartDrawerBodyScroll() {
  window.themeScrollLock && window.themeScrollLock.lock();
}

function unlockCartDrawerBodyScroll() {
  window.themeScrollLock && window.themeScrollLock.unlock();
}

function syncCartDeliveryDates(deliveryBy) {
  const dateValue = (deliveryBy || "").trim();
  const rows = document.querySelectorAll(".mm-cart-delivery-row");
  const dateTargets = document.querySelectorAll(".mm-cart-delivery-date");
  const hiddenTargets = document.querySelectorAll(".edd-date-cart");

  dateTargets.forEach((el) => {
    el.textContent = dateValue;
    const row = el.closest(".mm-cart-delivery-row");
    if (row) {
      row.classList.toggle("is-visible", !!dateValue);
    }
  });

  hiddenTargets.forEach((el) => {
    el.textContent = dateValue;
  });

  rows.forEach((row) => {
    row.classList.toggle("is-visible", !!dateValue);
  });
}

let ctVariantOptionClampRaf = null;

function clampAjaxCartVariantOptions(root) {
  const scope = root || document;
  const groups = scope.querySelectorAll(".mm-ajaxcart-item .variant_option");

  groups.forEach((group) => {
    const items = Array.from(group.querySelectorAll("p"));
    if (items.length <= 1) return;

    items.forEach((item) => {
      item.hidden = false;
    });

    const containerWidth = group.clientWidth;
    if (!containerWidth) return;

    const computed = window.getComputedStyle(group);
    const gap = parseFloat(computed.columnGap || computed.gap || "0") || 0;

    let usedWidth = 0;

    items.forEach((item, index) => {
      const itemWidth = Math.ceil(item.scrollWidth || item.getBoundingClientRect().width || 0);

      if (index === 0) {
        usedWidth = itemWidth;
        return;
      }

      if (usedWidth + gap + itemWidth <= containerWidth) {
        usedWidth += gap + itemWidth;
        return;
      }

      item.hidden = true;
    });
  });
}

function scheduleClampAjaxCartVariantOptions() {
  if (ctVariantOptionClampRaf) {
    cancelAnimationFrame(ctVariantOptionClampRaf);
  }

  ctVariantOptionClampRaf = requestAnimationFrame(function () {
    ctVariantOptionClampRaf = requestAnimationFrame(function () {
      clampAjaxCartVariantOptions(document);
    });
  });
}

if (!window.__ctVariantOptionClampResizeBound) {
  window.__ctVariantOptionClampResizeBound = true;
  window.addEventListener("resize", scheduleClampAjaxCartVariantOptions, { passive: true });
}

function getCartCouponsPopup() {
  return document.querySelector("[data-cart-coupons-popup]");
}

function syncCartCouponInputApplyState(input) {
  if (!input) return;
  var popup = input.closest("[data-cart-coupons-popup]");
  var applyButton = popup && popup.querySelector("[data-cart-coupons-input-apply]");
  if (!applyButton) return;

  var code = String(input.value || "").trim().replace(/[^A-Za-z0-9]/g, "");
  applyButton.disabled = code.length < 3;
}

function openCartCouponsPopup() {
  var popup = getCartCouponsPopup();
  if (!popup) return;
  popup.classList.add("is-open");
  popup.setAttribute("aria-hidden", "false");
  document.body.classList.add("ct-cart-coupons-open");
  var input = popup.querySelector("[data-cart-coupons-input]");
  if (input) {
    syncCartCouponInputApplyState(input);
    window.setTimeout(function () {
      if (document.body.classList.contains("ct-cart-coupons-open")) {
        input.focus();
      }
    }, 50);
  }
}

function closeCartCouponsPopup() {
  var popup = getCartCouponsPopup();
  if (!popup) return;
  popup.classList.remove("is-open");
  popup.setAttribute("aria-hidden", "true");
  document.body.classList.remove("ct-cart-coupons-open");
}

function ensureCartCouponErrorToastRoot() {
  var rootId = "ct-cart-coupon-error-toast-root";
  var root = document.getElementById(rootId);

  if (!root) {
    root = document.createElement("div");
    root.id = rootId;
    root.style.position = "fixed";
    root.style.top = "24px";
    root.style.left = "50%";
    root.style.transform = "translateX(-50%)";
    root.style.zIndex = "2147483647";
    root.style.isolation = "isolate";
    root.style.pointerEvents = "none";
    root.style.display = "flex";
    root.style.flexDirection = "column";
    root.style.alignItems = "center";
    root.style.gap = "10px";
    document.body.appendChild(root);
  }

  return root;
}

function showCartCouponErrorToast(message) {
  var text = String(message || "Coupon not applicable");
  if (text === "Coupon not applicable" && window.clevertap && clevertap.event && typeof clevertap.event.push === "function") {
    var cartValue = Number(document.querySelector(".cart-coupons-main") && document.querySelector(".cart-coupons-main").getAttribute("data-cart-subtotal") || 0) / 100;
    clevertap.event.push("Coupon Apply Failed", {
      coupon_code: window.__ctLastCouponCodeTried || "",
      cart_value: cartValue,
      failure_reason: "coupon_not_applicable",
      cart_band: getCartCouponBand(cartValue)
    });
  }
  var root = ensureCartCouponErrorToastRoot();
  if (!root) return;

  var toast = document.createElement("div");
  toast.className = "ct-cart-coupon-error-toast";
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");
  toast.style.pointerEvents = "auto";
  toast.style.background = "#ffffff";
  toast.style.color = "#454545";
  toast.style.borderRadius = "10px";
  toast.style.boxShadow = "-2px -2px 4px 0px rgba(0, 0, 0, 0.1)";
  toast.style.borderBottom = "2px solid #ffd949";
  toast.style.padding = "8px 12px";
  toast.style.fontSize = "14px";
  toast.style.fontWeight = "600";
  toast.style.lineHeight = "1.2";
  toast.style.maxWidth = "calc(100vw - 32px)";
  toast.style.textAlign = "center";
  toast.textContent = text;

  root.appendChild(toast);

  window.setTimeout(function () {
    toast.style.transition = "opacity 0.2s ease, transform 0.2s ease";
    toast.style.opacity = "0";
    toast.style.transform = "translateY(-10px)";
    window.setTimeout(function () {
      if (toast && toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 220);
  }, 2800);
}

function showCartCouponToast(message) {
  try {
    showCartCouponErrorToast(message);
    return;
  } catch (error) {}

  var text = String(message || "Coupon not applicable");
  if (window.KToast && typeof window.KToast.error === "function") {
    window.KToast.error(text);
    return;
  }

  window.alert(text);
}

function setCartCouponInputApplyButtonState(triggerEl, state, label) {
  if (!triggerEl) return;
  var $trigger = $(triggerEl);
  if (!$trigger.length || !$trigger.is("[data-cart-coupons-input-apply]")) return;

  var normalizedState = String(state || "").toLowerCase();
  var isLoadingState = normalizedState === "loading";

  if (isLoadingState) {
    if (!$trigger.data("original-html")) {
      $trigger.data("original-html", $trigger.html());
    }
    $trigger.addClass("is-loading");
    $trigger.attr("aria-busy", "true");
    $trigger.html('<span class="cart-coupons-loader" aria-hidden="true"></span><span class="visually-hidden">' + String(label || "Applying") + "</span>");
    return;
  }

  var originalHtml = $trigger.data("original-html");
  if (originalHtml != null) {
    $trigger.html(originalHtml);
    $trigger.removeData("original-html");
  }
  $trigger.removeClass("is-loading");
  $trigger.removeAttr("aria-busy");
}

function escapeCartCouponHtml(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatCartCouponMoney(value) {
  var amount = Number(value);
  if (!isFinite(amount) || amount <= 0) return "₹0";
  var formatter = typeof Intl !== "undefined" && Intl.NumberFormat
    ? new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      })
    : null;
  if (formatter) {
    return "₹" + formatter.format(amount);
  }
  var rounded = Math.round(amount);
  if (Math.abs(amount - rounded) < 0.001) {
    return "₹" + rounded;
  }
  return "₹" + amount.toFixed(2).replace(/\.?0+$/, "");
}

function formatCartCouponMoneyMinor(value) {
  var amount = Number(value);
  if (!isFinite(amount) || amount <= 0) return "₹0";
  return formatCartCouponMoney(amount / 100);
}

function isCartCouponPercentageOffer(offer) {
  var discountAmount = Number(offer && offer.discountAmount);
  return isFinite(discountAmount) && discountAmount > 0 && discountAmount < 1;
}

function formatCartCouponDiscountValue(offer) {
  if (isCartCouponPercentageOffer(offer)) {
    return Math.round(Number(offer.discountAmount) * 100) + "%";
  }
  return formatCartCouponMoney(offer.discountAmount);
}

function formatCartCouponDiscountLabel(offer) {
  return formatCartCouponDiscountValue(offer) + " off";
}

function formatCartCouponDiscountSubtitle(offer) {
  return "Get Additional " + formatCartCouponDiscountValue(offer) + " OFF on Orders";
}

function parseCartCouponCodeFromTitle(title) {
  var source = String(title || "").trim();
  if (!source) return "";

  var match = source.match(/Discount code\s+([A-Za-z0-9_-]+)/i);
  if (match && match[1]) {
    return String(match[1]).trim();
  }

  source = source.replace(/\(\s*-/g, "(");
  source = source.replace(/\s*automatic discount\s*$/i, "");
  source = source.replace(/\s*discount code\s*/i, "");
  source = source.split(" (")[0].trim();
  source = source.replace(/\s+/g, " ");

  if (/^[A-Za-z0-9_-]+$/.test(source) && /[A-Za-z]/.test(source) && /\d/.test(source)) {
    return source;
  }

  match = source.match(/\b([A-Za-z][A-Za-z0-9_-]*\d[A-Za-z0-9_-]*)\b/);
  if (match && match[1]) {
    return match[1];
  }

  return "";
}

function getCartCouponAppliedIconMarkup() {
  return '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="30" height="30" rx="8" fill="#1F8D0D"/><path d="M9 16.2516L12.1 19.1516L21 10.8516" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

function findCartCouponOfferByAmount(offers, amountMinor) {
  var targetAmount = Number(amountMinor);
  if (!isFinite(targetAmount) || targetAmount <= 0) return null;

  var matched = (Array.isArray(offers) ? offers : []).filter(function (offer) {
    return Math.round(Number(offer && offer.discountAmount || 0) * 100) === Math.round(targetAmount);
  });

  if (!matched.length) return null;
  return getSortedCartCouponOffers(matched).slice(-1)[0] || matched[0] || null;
}

function normalizeCartCouponOffer(rawOffer) {
  var offer = rawOffer || {};
  var code = String(offer.couponCode || offer.code || offer.title || "").trim().toUpperCase();
  var discountAmount = Number(offer.discountAmount != null ? offer.discountAmount : offer.amount);
  var minimumRequirement = offer.minimumRequirement || {};
  var minimumAmount = Number(minimumRequirement.minimumAmount || 0);
  var eligibility = String(offer.eligibility || "").trim().toUpperCase();
  return {
    code: code,
    discountAmount: isFinite(discountAmount) ? discountAmount : 0,
    currencyCode: String(offer.currencyCode || minimumRequirement.currencyCode || "INR").trim().toUpperCase(),
    eligibility: eligibility,
    minimumAmount: isFinite(minimumAmount) ? minimumAmount : 0,
    minimumType: String(minimumRequirement.type || "").trim().toUpperCase()
  };
}

function buildCartCouponSubtitle(offer) {
  var firstLine = formatCartCouponDiscountSubtitle(offer);
  var secondLine = "";
  if (offer.minimumAmount > 0) {
    secondLine = offer.minimumType === "QUANTITY"
      ? "Minimum quantity " + offer.minimumAmount
      : "On orders above " + formatCartCouponMoney(offer.minimumAmount);
  }
  return {
    firstLine: firstLine,
    secondLine: secondLine
  };
}

function buildCartCouponItemHtml(offer, isBestEligible, isEligible, amountToUnlock) {
  var subtitle = buildCartCouponSubtitle(offer);
  var amountLabel = formatCartCouponDiscountLabel(offer);
  var minimumText = subtitle.secondLine || "";
  return [
    '<div class="cart-coupons-popup__item', isBestEligible ? ' is-best-eligible' : '', !isEligible ? ' is-ineligible' : '', '" data-coupon-code="', escapeCartCouponHtml(offer.code), '">',
      '<div class="cart-coupons-popup__item-left">',
        '<div class="cart-coupons-popup__item-icon" aria-hidden="true">',
          '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17.0968 10.095C17.7124 10.7106 18.0202 11.0183 18.0202 11.4008C18.0202 11.7832 17.7124 12.091 17.0968 12.7065L12.7066 17.0968C12.091 17.7124 11.7832 18.0202 11.4008 18.0202C11.0183 18.0202 10.7106 17.7124 10.095 17.0968L2.9393 9.94113C2.67244 9.67426 2.539 9.54083 2.46872 9.37115C2.39844 9.20147 2.39844 9.01277 2.39844 8.63536V4.24507C2.39844 3.37456 2.39844 2.9393 2.66887 2.66887C2.9393 2.39844 3.37456 2.39844 4.24507 2.39844H8.63536C9.01277 2.39844 9.20147 2.39844 9.37115 2.46872C9.54083 2.539 9.67426 2.67244 9.94113 2.9393L17.0968 10.095Z" fill="#454545" stroke="#454545" stroke-width="1.86594" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.93356 7.79974C7.41221 7.79974 7.80023 7.41172 7.80023 6.93307C7.80023 6.45443 7.41221 6.06641 6.93356 6.06641C6.45491 6.06641 6.06689 6.45443 6.06689 6.93307C6.06689 7.41172 6.45491 7.79974 6.93356 7.79974Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '</div>',
        '<div class="cart-coupons-popup__item-copy">',
          '<div class="cart-coupons-popup__item-top">',
            '<div class="cart-coupons-popup__item-description">',
              '<div class="cart-coupons-popup__item-subtitle">',
                escapeCartCouponHtml(subtitle.firstLine),
              '</div>',
              minimumText ? '<div class="cart-coupons-popup__item-minimum">' + escapeCartCouponHtml(minimumText) + '</div>' : '',
            '</div>',
            '<div class="cart-coupons-popup__item-meta">',
              '<div class="cart-coupons-popup__item-amount">', escapeCartCouponHtml(amountLabel), '</div>',
            '</div>',
          '</div>',
          '<div class="cart-coupons-popup__item-bottom">',
            '<div class="cart-coupons-popup__item-title">', escapeCartCouponHtml(offer.code), '</div>',
            isEligible ? '<button type="button" class="cart-coupons-popup__apply" data-coupon-code="' + escapeCartCouponHtml(offer.code) + '" data-coupon-action="apply">Apply</button>' : '',
          '</div>',
          !isEligible && amountToUnlock <= 1000 ? '<div class="cart-coupons-popup__item-ineligible">Add ' + escapeCartCouponHtml(formatCartCouponMoney(amountToUnlock)) + ' more to use this</div>' : '',
        '</div>',
      '</div>',
    '</div>'
  ].join("");
}

function getCartCouponApiUrl() {
  var baseUrl = String(window.apiUrl || window.devUrl || "").trim().replace(/\/$/, "");
  if (!baseUrl) return "";
  return baseUrl + "/customer/all-coupon";
}

function fetchCartCouponOffers() {
  if (window.__ctCartCouponOffersPromise) {
    return window.__ctCartCouponOffersPromise;
  }

  var endpoint = getCartCouponApiUrl();
  if (!endpoint) {
    return Promise.resolve([]);
  }

  window.__ctCartCouponOffersPromise = fetch(endpoint, {
    headers: {
      "Accept": "application/json"
    }
  })
    .then(function (response) {
      if (!response.ok) throw new Error("Coupon API failed");
      return response.json();
    })
    .then(function (data) {
      var items = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : []);
      var offers = items.map(normalizeCartCouponOffer).filter(function (offer) {
        return !!offer.code;
      });
      return offers;
    })
    .then(function (offers) {
      window.__ctCartCouponOffersPromise = null;
      return offers;
    })
    .catch(function (error) {
      window.__ctCartCouponOffersPromise = null;
      throw error;
    });

  return window.__ctCartCouponOffersPromise;
}

function getPrimaryCartCouponOffer(offers, activeCode) {
  var normalizedActiveCode = String(activeCode || "").trim().toUpperCase();
  if (normalizedActiveCode) {
    var activeOffer = offers.find(function (offer) {
      return offer.code === normalizedActiveCode;
    });
    if (activeOffer) return activeOffer;
  }

  var allCustomerOffer = offers.find(function (offer) {
    return offer.eligibility === "ALL_CUSTOMERS";
  });
  return allCustomerOffer || offers[0] || null;
}

function getSortedCartCouponOffers(offers) {
  return (Array.isArray(offers) ? offers : []).slice().sort(function (a, b) {
    var minA = Number(a && a.minimumAmount || 0);
    var minB = Number(b && b.minimumAmount || 0);
    if (minA !== minB) return minA - minB;

    var discountA = Number(a && a.discountAmount || 0);
    var discountB = Number(b && b.discountAmount || 0);
    if (discountA !== discountB) return discountB - discountA;

    return String(a && a.code || "").localeCompare(String(b && b.code || ""));
  });
}

function getHighestUnlockedCartCouponOffer(offers, subtotalRupees) {
  var subtotal = Number(subtotalRupees || 0);
  if (!isFinite(subtotal) || subtotal < 0) subtotal = 0;
  var sortedOffers = getSortedCartCouponOffers(offers);
  var unlocked = sortedOffers.filter(function (offer) {
    return Number(offer && offer.minimumAmount || 0) <= subtotal;
  });
  return unlocked.length ? unlocked[unlocked.length - 1] : null;
}

function getNextCartCouponOffer(offers, subtotalRupees) {
  var subtotal = Number(subtotalRupees || 0);
  if (!isFinite(subtotal) || subtotal < 0) subtotal = 0;
  var sortedOffers = getSortedCartCouponOffers(offers);
  for (var index = 0; index < sortedOffers.length; index++) {
    if (Number(sortedOffers[index] && sortedOffers[index].minimumAmount || 0) > subtotal) {
      return sortedOffers[index];
    }
  }
  return null;
}

function getCartCouponBand(subtotalRupees) {
  var subtotal = Number(subtotalRupees || 0);
  if (!isFinite(subtotal) || subtotal < 0) subtotal = 0;

  if (subtotal < 1000) return "0-999";
  if (subtotal < 2000) return "1000-1999";
  if (subtotal < 3000) return "2000-2999";
  if (subtotal < 5000) return "3000-4999";
  return "5000+";
}

function getCartCouponCityTier() {
  var locationStoreRaw = window.KushalsStorageTTL ? window.KushalsStorageTTL.get("location_store") : localStorage.getItem("location_store");
  if (!locationStoreRaw) return "";

  try {
    var locationStore = JSON.parse(locationStoreRaw);
    var cityTier = locationStore && (locationStore.city_tier || locationStore.cityTier || locationStore.tier || locationStore.city_tier_name);
    return String(cityTier || "").trim();
  } catch (error) {
    return "";
  }
}

function pushCartCouponShownEventFromRoot(root) {
  if (!root || !window.clevertap || !clevertap.event || typeof clevertap.event.push !== "function") return;

  var couponCode = String(root.dataset && root.dataset.ctRecommendedCoupon || "").trim().toUpperCase();
  var discountAmount = Number(root.dataset && root.dataset.ctRecommendedCouponDiscount || 0);
  var cartValue = Number(root.getAttribute("data-cart-subtotal") || 0) / 100;
  var cartBand = String(root.dataset && root.dataset.ctCartBand || getCartCouponBand(cartValue)).trim();
  var minCartValue = Number(root.dataset && root.dataset.ctRecommendedCouponMin || 0);
  var isBestOffer = String(root.dataset && root.dataset.ctRecommendedCouponIsBest || "").toLowerCase() === "true";
  var cityTier = getCartCouponCityTier();

  if (!couponCode) return;

  var shownSignature = [
    couponCode,
    discountAmount,
    cartValue,
    cartBand,
    minCartValue,
    isBestOffer ? "1" : "0",
    cityTier
  ].join("::");

  if (window.__ctCouponShownSignature === shownSignature) return;
  window.__ctCouponShownSignature = shownSignature;

  clevertap.event.push("Coupon Shown", {
    coupon_code: couponCode,
    discount_amount: discountAmount,
    cart_value: cartValue,
    cart_band: cartBand || getCartCouponBand(cartValue),
    min_cart_value: minCartValue,
    is_best_offer: isBestOffer,
    city_tier: cityTier
  });
}

function hydrateCartCouponsUI() {
  var root = document.querySelector(".cart-coupons-main");
  if (!root) return Promise.resolve([]);

  return fetchCartCouponOffers().then(function (offers) {
    if (!offers.length) {
      root.remove();
      return offers;
    }

    root.hidden = false;

    var activeCode = String(root.getAttribute("data-active-coupon") || "").trim().toUpperCase();
    var activeTitle = String(root.getAttribute("data-active-coupon-title") || "").trim();
    var activeIsAutomatic = String(root.getAttribute("data-active-coupon-automatic") || "").toLowerCase() === "true";
    var activeDiscountAmount = Number(root.getAttribute("data-active-discount-amount") || 0);
    var cartTotalDiscountMinor = Number(root.getAttribute("data-cart-total-discount") || 0);
    var subtotalMinor = Number(root.getAttribute("data-cart-subtotal") || 0);
    var subtotalRupees = isFinite(subtotalMinor) ? subtotalMinor / 100 : 0;
    var summaryLabel = root.querySelector("[data-cart-coupons-summary-label]");
    var summaryAmount = root.querySelector("[data-cart-coupons-summary-amount]");
    var summaryAction = root.querySelector("[data-cart-coupons-summary-action]");
    var summaryCode = root.querySelector("[data-cart-coupons-summary-code]");
    var popupActiveDesc = root.querySelector("[data-cart-coupons-active-desc]");
    var cardApply = root.querySelector("[data-cart-coupons-card-apply]");
    var cardIcon = root.querySelector(".cart-coupons-card__icon");
    var parsedTitleCode = parseCartCouponCodeFromTitle(activeTitle);
    var activeLookupCode = (parsedTitleCode || activeCode || "").trim().toUpperCase();
    var activeOffer = activeLookupCode ? offers.find(function (offer) {
      return offer.code === activeLookupCode;
    }) : null;
    var matchedOfferByAmount = !activeLookupCode ? findCartCouponOfferByAmount(offers, activeDiscountAmount > 0 ? activeDiscountAmount : cartTotalDiscountMinor) : null;
    var activeSummaryOffer = activeOffer || matchedOfferByAmount;
    var activeDisplayCode = (activeSummaryOffer && activeSummaryOffer.code)
      || parsedTitleCode
      || activeCode
      || (activeTitle && activeTitle !== "automatic discount" ? activeTitle : "")
      || "SILVER20";
    var hasCartDiscount = !!activeTitle || !!activeLookupCode || activeDiscountAmount > 0 || cartTotalDiscountMinor > 0;
    var bestUnlockedOffer = !hasCartDiscount ? getHighestUnlockedCartCouponOffer(offers, subtotalRupees) : null;
    var nextOffer = !hasCartDiscount && !bestUnlockedOffer ? getNextCartCouponOffer(offers, subtotalRupees) : null;
    var visibleRecommendedOffer = activeSummaryOffer || bestUnlockedOffer || nextOffer;
    var unlockedOffers = offers.filter(function (offer) {
      return Number(offer && offer.minimumAmount || 0) <= subtotalRupees;
    });
    var lockedOffers = offers.length - unlockedOffers.length;
    var viewSignature = [
      activeCode || "",
      subtotalRupees,
      offers.map(function (offer) {
        return [offer.code, offer.discountAmount, offer.minimumAmount, offer.eligibility].join(":");
      }).join("|")
    ].join("::");

    if (window.console && typeof window.console.log === "function") {
      window.console.log("[CT Coupons] active discount snapshot", {
        activeCode: activeCode,
        activeTitle: activeTitle,
        activeIsAutomatic: activeIsAutomatic,
        parsedTitleCode: parsedTitleCode,
        activeLookupCode: activeLookupCode,
        activeDiscountAmount: activeDiscountAmount,
        cartTotalDiscountMinor: cartTotalDiscountMinor,
        matchedOfferByAmount: matchedOfferByAmount && matchedOfferByAmount.code,
        hasCartDiscount: hasCartDiscount,
        activeDisplayCode: activeDisplayCode,
        activeOfferMatched: !!activeOffer,
        subtotalRupees: subtotalRupees
      });
    }

    if (window.__ctCartCouponViewedSignature !== viewSignature) {
      window.__ctCartCouponViewedSignature = viewSignature;
    }

    root.dataset.ctRecommendedCoupon = visibleRecommendedOffer ? visibleRecommendedOffer.code : "";
    root.dataset.ctRecommendedCouponDiscount = visibleRecommendedOffer ? visibleRecommendedOffer.discountAmount : "";
    root.dataset.ctRecommendedCouponMin = visibleRecommendedOffer ? visibleRecommendedOffer.minimumAmount : "";
    root.dataset.ctRecommendedCouponIsBest = bestUnlockedOffer && visibleRecommendedOffer && bestUnlockedOffer.code === visibleRecommendedOffer.code ? "true" : "false";
    root.dataset.ctCartBand = getCartCouponBand(subtotalRupees);

    if (cardIcon && hasCartDiscount) {
      cardIcon.innerHTML = getCartCouponAppliedIconMarkup();

      if (window.__ctCartCouponAnimateApplied) {
        cardIcon.classList.remove("is-popping");
        void cardIcon.offsetWidth;
        cardIcon.classList.add("is-popping");
        window.__ctCartCouponAnimateApplied = false;

        setTimeout(function () {
          cardIcon.classList.remove("is-popping");
        }, 420);
      }
    }

    if (hasCartDiscount) {
      if (activeSummaryOffer) {
        if (summaryLabel) summaryLabel.textContent = "You Saved";
        if (summaryAmount) summaryAmount.textContent = formatCartCouponDiscountValue(activeSummaryOffer);
        if (summaryAction) {
          summaryAction.textContent = "with";
          summaryAction.hidden = false;
        }
        if (summaryCode) {
          summaryCode.textContent = "'" + activeSummaryOffer.code + "'";
          summaryCode.hidden = false;
        }
        if (popupActiveDesc) {
          popupActiveDesc.textContent = buildCartCouponSubtitle(activeSummaryOffer).secondLine || "";
        }
        if (cardApply) {
          cardApply.setAttribute("data-coupon-code", activeSummaryOffer.code);
          cardApply.setAttribute("data-coupon-action", "remove");
          cardApply.textContent = "Remove";
          cardApply.removeAttribute("disabled");
          cardApply.hidden = false;
        }
      } else {
        if (summaryLabel) summaryLabel.textContent = "You Saved";
        if (summaryAmount) summaryAmount.textContent = formatCartCouponMoneyMinor(activeDiscountAmount > 0 ? activeDiscountAmount : cartTotalDiscountMinor);
        if (summaryAction) {
          summaryAction.textContent = "with";
          summaryAction.hidden = false;
        }
        if (summaryCode) {
          summaryCode.textContent = "'" + activeDisplayCode + "'";
          summaryCode.hidden = false;
        }
        if (cardApply) {
          if (activeLookupCode || activeCode) {
            cardApply.setAttribute("data-coupon-code", activeDisplayCode);
            cardApply.setAttribute("data-coupon-action", "remove");
            cardApply.textContent = "Remove";
            cardApply.removeAttribute("disabled");
            cardApply.hidden = false;
          } else {
            cardApply.setAttribute("data-coupon-code", "");
            cardApply.setAttribute("data-coupon-action", "apply");
            cardApply.textContent = "Apply";
            cardApply.setAttribute("disabled", "disabled");
            cardApply.hidden = true;
          }
        }
      }
    } else if (bestUnlockedOffer) {
      if (summaryLabel) summaryLabel.textContent = "Unlocked";
      if (summaryAmount) summaryAmount.textContent = formatCartCouponDiscountValue(bestUnlockedOffer);
      if (summaryAction) summaryAction.textContent = "with";
      if (summaryAction) summaryAction.hidden = false;
      if (summaryCode) summaryCode.textContent = "'" + bestUnlockedOffer.code + "'";
      if (summaryCode) summaryCode.hidden = false;
      if (cardApply) {
        cardApply.setAttribute("data-coupon-code", bestUnlockedOffer.code);
        cardApply.setAttribute("data-coupon-action", "apply");
        cardApply.textContent = "Apply";
        cardApply.removeAttribute("disabled");
        cardApply.hidden = false;
      }
    } else {
      var nextThresholdText = nextOffer ? formatCartCouponMoney(Math.max(0, Number(nextOffer.minimumAmount || 0) - subtotalRupees)) : "--";
      if (summaryLabel) summaryLabel.textContent = "Add";
      if (summaryAmount) summaryAmount.textContent = nextThresholdText;
      if (summaryAction) summaryAction.textContent = "more to unlock";
      if (summaryAction) summaryAction.hidden = false;
      if (summaryCode) {
        summaryCode.textContent = nextOffer ? "'" + nextOffer.code + "'" : "'coupon available'";
        summaryCode.hidden = false;
      }
      if (cardApply) {
        cardApply.setAttribute("data-coupon-code", nextOffer ? nextOffer.code : "");
        cardApply.setAttribute("data-coupon-action", "apply");
        cardApply.textContent = "Apply";
        cardApply.setAttribute("disabled", "disabled");
        cardApply.hidden = false;
      }
    }

    // Keep the freshly-rendered card in loading state until Applied is painted.
    if (cardApply && window.__ctCartCouponLoading) {
      cardApply.classList.add("is-loading");
      cardApply.setAttribute("aria-busy", "true");
      cardApply.innerHTML = '<span class="cart-coupons-loader" aria-hidden="true"></span><span class="visually-hidden">Applying</span>';
      document.body.classList.remove("ct-cart-coupon-applying");
    }

    var list = root.querySelector("[data-cart-coupons-list]");
    var empty = root.querySelector("[data-cart-coupons-empty]");
    if (!list) return offers;

    var renderOffers = (activeCode ? offers.filter(function (offer) {
      return offer.code !== activeCode;
    }) : offers).slice();
    if (bestUnlockedOffer) {
      renderOffers = [bestUnlockedOffer].concat(renderOffers.filter(function (offer) {
        return offer.code !== bestUnlockedOffer.code;
      }));
    }
    var renderSignature = renderOffers.map(function (offer) {
      var amountToUnlock = Math.max(0, Number(offer && offer.minimumAmount || 0) - subtotalRupees);
      var isEligible = amountToUnlock <= 0;
      return [offer.code, offer.discountAmount, offer.minimumAmount, offer.eligibility, amountToUnlock, isEligible].join(":");
    }).join("|");

    if (list.dataset.ctCouponsActive === renderSignature) {
      return offers;
    }

    list.dataset.ctCouponsActive = renderSignature;

    if (renderOffers.length) {
      list.innerHTML = renderOffers.map(function (offer) {
        var amountToUnlock = Math.max(0, Number(offer && offer.minimumAmount || 0) - subtotalRupees);
        var isEligible = amountToUnlock <= 0;
        return buildCartCouponItemHtml(
          offer,
          !!bestUnlockedOffer && offer.code === bestUnlockedOffer.code,
          isEligible,
          amountToUnlock
        );
      }).join("");
      list.hidden = false;
      if (empty) empty.hidden = true;
    } else {
      list.innerHTML = "";
      list.hidden = true;
      if (empty) empty.hidden = true;
    }

    return offers;
  });
}

window.ctCartCouponsHydrate = hydrateCartCouponsUI;

function getCartCouponButtonsByCode(code) {
  var couponCode = String(code || "").trim().toUpperCase();
  if (!couponCode) return $();
  return $(".cart-coupons-card__apply[data-coupon-code=\"" + couponCode + "\"], .cart-coupons-popup__apply[data-coupon-code=\"" + couponCode + "\"]");
}

function setCartCouponButtonState(buttons, state, code) {
  var $buttons = buttons && buttons.jquery ? buttons : $(buttons || []);
  if (!$buttons.length) return;

  var normalizedState = String(state || "").toLowerCase();
  var couponCode = String(code || $buttons.first().data("coupon-code") || "").trim().toUpperCase();
  var isApplyState = normalizedState === "apply";
  var isRemoveState = normalizedState === "remove";
  var isLoadingState = normalizedState === "loading";
  var isAppliedState = normalizedState === "applied";

  $buttons.each(function () {
    var $btn = $(this);
    var label = "Apply";
    var action = "apply";

    $btn.removeClass("is-loading is-active is-applied");

    if (isRemoveState) {
      label = "Remove";
      action = "remove";
      $btn.addClass("is-active");
    } else if (isAppliedState) {
      label = "Applied";
      action = "remove";
      $btn.addClass("is-applied");
    } else if (isLoadingState) {
      label = $btn.data("loading-label") || "Applying";
      action = "apply";
      $btn.addClass("is-loading");
      $btn.attr("aria-busy", "true");
      $btn.html('<span class="cart-coupons-loader" aria-hidden="true"></span><span class="visually-hidden">' + label + "</span>");
      if (couponCode) {
        $btn.attr("data-coupon-code", couponCode);
      }
      $btn.attr("data-coupon-action", action);
      return;
    } else if (isApplyState) {
      label = "Apply";
      action = "apply";
    }

    if (!isLoadingState) {
      $btn.removeAttr("aria-busy");
    }

    if (couponCode) {
      $btn.attr("data-coupon-code", couponCode);
    }
    $btn.attr("data-coupon-action", action);
    $btn.text(label);
  });
}

function updateCartCouponCode(code, action, triggerEl) {
  var couponCode = String(code || "").trim().toUpperCase();
  var couponAction = String(action || "apply").trim().toLowerCase();
  var discountValue = couponAction === "remove" ? "" : couponCode;

  var $trigger = triggerEl ? $(triggerEl) : $();
  if ($trigger.length && $trigger.data("processing")) return;
  if ($trigger.length) {
    $trigger.data("processing", true);
    $trigger.attr("disabled", "disabled");
  }

  var loadingLabel = couponAction === "remove" ? "Remove" : "Applied";
  var $couponButtons = getCartCouponButtonsByCode(couponCode);
  $couponButtons.data("loading-label", loadingLabel);
  setCartCouponButtonState($couponButtons, "loading", couponCode);
  setCartCouponInputApplyButtonState(triggerEl, "loading", couponAction === "remove" ? "Remove" : "Applying");

  if (window.__cartCouponUiTimer) {
    clearTimeout(window.__cartCouponUiTimer);
    window.__cartCouponUiTimer = null;
  }

  if (window.__cartCouponConfettiTimer) {
    clearTimeout(window.__cartCouponConfettiTimer);
    window.__cartCouponConfettiTimer = null;
  }

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      discount: discountValue
    })
  })
    .then(function (response) {
      return response.json();
    })
    .then(function () {
      return fetch("/cart.js", {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      }).then(function (cartResponse) {
        return cartResponse.json();
      });
    })
    .then(function (cart) {
      var cartDiscounts = Array.isArray(cart && cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
      var appliedCouponCode = cartDiscounts.length ? String(cartDiscounts[0].title || "").trim().toUpperCase() : "";
      var isApplied = couponAction === "remove" ? !appliedCouponCode : appliedCouponCode === couponCode;
      var cartValueRupees = Number(cart && cart.items_subtotal_price || 0) / 100;
      var cartValueBeforeDiscount = Number(cart && cart.original_total_price || 0) / 100;
      var cartValueAfterDiscount = Number(cart && cart.total_price || 0) / 100;
      var cityTier = getCartCouponCityTier();

      if (!isApplied) {
        window.__ctLastCouponCodeTried = couponCode;
        setCartCouponButtonState(getCartCouponButtonsByCode(couponCode), "apply", couponCode);
        setCartCouponInputApplyButtonState(triggerEl, "reset");
        showCartCouponToast("Coupon not applicable");
        return;
      }

      if (couponAction === "apply") {
        window.__ctCartCouponAnimateApplied = true;
        var appliedSignature = [
          couponCode,
          cartValueBeforeDiscount,
          cartValueAfterDiscount,
          getCartCouponBand(cartValueAfterDiscount),
          cityTier
        ].join("::");

        if (window.__ctCouponAppliedSignature !== appliedSignature) {
          window.__ctCouponAppliedSignature = appliedSignature;
          if (window.clevertap && clevertap.event && typeof clevertap.event.push === "function") {
            clevertap.event.push("Coupon Applied", {
              coupon_code: couponCode,
              discount_amount: Math.max(0, cartValueBeforeDiscount - cartValueAfterDiscount),
              cart_value_before_discount: cartValueBeforeDiscount,
              cart_value_after_discount: cartValueAfterDiscount,
              cart_band: getCartCouponBand(cartValueAfterDiscount),
              city_tier: cityTier
            });
          }
        }
      } else if (couponAction === "remove") {
        var removedBy = triggerEl && $(triggerEl).is("[data-cart-coupons-input-apply]")
          ? "popup_input"
          : (triggerEl && $(triggerEl).is(".cart-coupons-card__apply") ? "summary_card" : "popup_list");
        var removedSignature = [
          couponCode,
          cartValueBeforeDiscount,
          cartValueAfterDiscount,
          removedBy
        ].join("::");

        if (window.__ctCouponRemovedSignature !== removedSignature) {
          window.__ctCouponRemovedSignature = removedSignature;
          if (window.clevertap && clevertap.event && typeof clevertap.event.push === "function") {
            clevertap.event.push("Coupon Removed", {
              coupon_code: couponCode,
              discount_amount: Math.max(0, cartValueBeforeDiscount - cartValueAfterDiscount),
              cart_value: cartValueAfterDiscount,
              removed_by: removedBy
            });
          }
        }
      }

      if (window.mmajaxcart && typeof window.mmajaxcart.AjaxcartRender === "function") {
        window.__ctCartCouponLoading = couponAction === "apply";
        if (couponAction === "apply") {
          document.body.classList.add("ct-cart-coupon-applying");
        }
        window.mmajaxcart.AjaxcartRender();
      }
      closeCartCouponsPopup();

      window.__cartCouponUiTimer = setTimeout(function () {
        if (couponAction === "apply") {
          setCartCouponButtonState(getCartCouponButtonsByCode(couponCode), "applied", couponCode);
          window.__cartCouponUiTimer = setTimeout(function () {
            setCartCouponButtonState(getCartCouponButtonsByCode(couponCode), "remove", couponCode);
            window.__cartCouponUiTimer = null;
          }, 1000);
        } else {
          setCartCouponButtonState(getCartCouponButtonsByCode(couponCode), "apply", couponCode);
          window.__cartCouponUiTimer = null;
        }
        window.__ctCartCouponLoading = false;
        window.setTimeout(function () {
          document.body.classList.remove("ct-cart-coupon-applying");
        }, 3000);
        setCartCouponInputApplyButtonState(triggerEl, "reset");
      }, 120);
    })
    .catch(function (error) {
      console.error("Unable to update cart coupon", error);
      if (couponAction === "apply") {
        window.__ctLastCouponCodeTried = couponCode;
        showCartCouponToast("Coupon not applicable");
      }
      window.__ctCartCouponLoading = false;
      document.body.classList.remove("ct-cart-coupon-applying");
      setCartCouponButtonState($couponButtons, couponAction === "remove" ? "remove" : "apply", couponCode);
      setCartCouponInputApplyButtonState(triggerEl, "reset");
    })
    .finally(function () {
      if ($trigger.length) {
        $trigger.data("processing", false);
        $trigger.removeAttr("disabled");
        $trigger.removeClass("is-loading");
        $trigger.removeData("loading-label");
      }
      setCartCouponInputApplyButtonState(triggerEl, "reset");
    });
}

window.mmajaxcart = {
  AjaxcartOpen: function () {
    const ajaxCart = $('.mm-ajaxcart');
    const ajaxOverlay = $('.mm-ajaxcart-overlay');

    lockCartDrawerBodyScroll();
    ajaxCart.addClass('has--opened');
    ajaxOverlay.addClass('has--active');

    clevertap.event.push("Cart Drawer Opened");

    if (typeof window.ctCartCouponsHydrate === "function") {
      window.ctCartCouponsHydrate().then(function () {
        pushCartCouponShownEventFromRoot(document.querySelector(".cart-coupons-main"));
      });
    } else {
      pushCartCouponShownEventFromRoot(document.querySelector(".cart-coupons-main"));
    }
  },

  AjaxcartClose: function () {
      const body = $('body');
      const ajaxCart = $('.mm-ajaxcart');
      const ajaxOverlay = $('.mm-ajaxcart-overlay');

      unlockCartDrawerBodyScroll();
      ajaxCart.removeClass('has--opened');
      ajaxOverlay.removeClass('has--active');
      clevertap.event.push("Cart Drawer Closed");

  },

  AjaxcartRender: function () {
    mmajaxcart._renderSeq = (mmajaxcart._renderSeq || 0) + 1;
    const renderSeq = mmajaxcart._renderSeq;
    $.ajax({
      url: '/cart',
      type: 'GET',
      cache: false,
      data: {
        view: 'ct-ajax',
        _: Date.now()
      }
    }).done(function (cart) {
        if (renderSeq !== mmajaxcart._renderSeq) return;
        $('.mm-ajaxcart').html(cart);
        if ($('.mm-ajaxcart').hasClass('has--opened') && typeof window.ctCartCouponsHydrate === "function") {
          window.ctCartCouponsHydrate();
        }
        scheduleClampAjaxCartVariantOptions();
      
        if(window.location.href.includes('/pages/product-bundling')) {
            updateCartElements(cart);
        }
        setTimeout(()=>{
          const apiPinCheckCalled = sessionStorage.getItem("eddPinCheckCart");
          // If API was already called and no reset is required, return early
          if (!apiPinCheckCalled) {
              const locationStoreRaw = localStorage.getItem('location_store');
              let dropPinCode = null;

              if (locationStoreRaw) {
                try {
                  dropPinCode = JSON.parse(locationStoreRaw)?.postal;
                } catch (error) {
                  console.error('Unable to parse location_store from localStorage', error);
                }
              }

              if (!dropPinCode || dropPinCode === 'undefined') {
                dropPinCode = localStorage.getItem('pin');
              }

              if (dropPinCode) {
                fetchDeliveryDate(560004, dropPinCode);
              } else {
                renderPreEddCheckMessage();
                syncCartDeliveryDates("");
              }
          } else {
              renderPreEddCheckMessage(apiPinCheckCalled);
              syncCartDeliveryDates(apiPinCheckCalled);
          }
        }, 1000);


        const rawWishlistData = sessionStorage.getItem('wishlistData');
        const wishlistData = rawWishlistData ? JSON.parse(rawWishlistData) : [];

        if (Array.isArray(wishlistData) && wishlistData.length > 0) {
            try {
                let cartWsItems = document.querySelectorAll('.cart-wishlist-items');
                cartWsItems.forEach(item => item.style.display = 'block');
                displayWishlist(wishlistData); // Call function with parsed data
            } catch (error) {
                console.error("Error parsing wishlistData:", error);
            }
        }

        // Get wishlist product IDs from localStorage and convert to a Set for fast lookup
        const wishlistDataPre = localStorage.getItem("local_wish_prod_data");

        let wishlistDataPrd;
        try {
            if (wishlistDataPre) {
                wishlistDataPrd = new Set(JSON.parse(wishlistDataPre) || []);
            } else {
                wishlistDataPrd = new Set();
            }
        } catch (error) {
            wishlistDataPrd = new Set();
            localStorage.setItem("local_wish_prod_data", JSON.stringify([]));
        }

        const cartItems = [...document.querySelectorAll(".mm-ajaxcart-item")];

        cartItems.forEach((el) => {
            let variantId = el.getAttribute("data-variant_id");

            if (wishlistDataPrd.has(variantId)) {
                setTimeout(() => {
                    let matchedAdd = document.querySelectorAll(`.ct_wishlist_addcart_btn-${variantId}`);
                    let matchedAdded = document.querySelectorAll(`.prd-added-cart-${variantId}`);

                    matchedAdd.forEach((addBtn, index) => {
                        if (addBtn.getAttribute('data-prod-variant-id') === variantId) {
                            addBtn.style.display = "none";
                            if (matchedAdded[index]) {
                                matchedAdded[index].style.display = "flex";
                            }
                        }
                    });
                }, 1000);
            }
        });

        /**** Timer Setup ****/
        // Keep the cart reservation timer disabled without removing the markup.
        // Flip this to true if the timer needs to be re-enabled later.
        const ENABLE_CART_HEADER_TIMER = false;

        function startTimer(duration, display) {
            if (!ENABLE_CART_HEADER_TIMER || !display) {
                return;
            }

            const startTime = Date.now();
            const endTime = startTime + duration * 1000;

            const interval = setInterval(function () {
                const currentTime = Date.now();
                const remainingTime = Math.max(0, Math.floor((endTime - currentTime) / 1000));

                const minutes = String(Math.floor(remainingTime / 60)).padStart(2, '0');
                const seconds = String(remainingTime % 60).padStart(2, '0');

                display.textContent = `${minutes}:${seconds}`;
                let cartHeaderTimer = document.querySelector('.cart_header_timer');
                if (cartHeaderTimer) cartHeaderTimer.style.display = 'block';
                localStorage.setItem('remainingTime', remainingTime);

                if (remainingTime <= 0) {
                    clearInterval(interval);
                    localStorage.setItem('popupHidden', 'true');
                    cartHeaderTimer.style.display = 'none';
                }
            }, 1000);
        }

        const display = document.querySelector('#time');
        const popupHidden = localStorage.getItem('popupHidden');
        const remainingTime = localStorage.getItem('remainingTime');

        /**** Custom Timer ****/
        let ct_timeLeft;
        let ct_timerInterval;

        function ct_updateTimer() {
            const ct_minutes = Math.floor(ct_timeLeft / 60);
            const ct_seconds = String(ct_timeLeft % 60).padStart(2, '0');
            ct_timeLeft--;

            if (ct_timeLeft < 0) {
                clearInterval(ct_timerInterval);
            } else {
                localStorage.setItem("ct_timeLeft", ct_timeLeft);
            }
        }

        function ct_startTimer() {
            ct_timerInterval = setInterval(ct_updateTimer, 1000);
        }

        function ct_startNewTimer() {
            ct_timeLeft = localStorage.getItem("ct_timeLeft") ? parseInt(localStorage.getItem("ct_timeLeft")) : 30;
            ct_startTimer();
        }

        const remain_time_left = localStorage.getItem("ct_timeLeft");
        if (remain_time_left > 0) {
            ct_startNewTimer();
        }

        // Fetch values from the DOM and localStorage
        const totalMainPrice = parseFloat($(cart).find(".theme-money-price").attr("data-price"));
        const countItem = $(".mm-emptycart-content").length;
        const storeData = localStorage.getItem('current_location');
        const ctLeftLocal = localStorage.getItem("ct_timeLeft");
        const cityArr = ['bengaluru'];

        // Check if the cart is empty
        if (ENABLE_CART_HEADER_TIMER && countItem === 0) {
            if (popupHidden === 'true') {
                let cart_timer = document.querySelector('.cart_header_timer');
                if(cart_timer) {
                    cart_timer.style.display = 'none';
                }
            } else {
                if (remainingTime) {
                    startTimer(remainingTime, display);
                } else {
                    const oneMinute = 60 * 5;
                    startTimer(oneMinute, display);
                }
            }

            // Check if the storeData is not in cityArr
            if (cityArr.indexOf(storeData) === -1) {
                if (ctLeftLocal === null && totalMainPrice > 500) {
                    ct_startNewTimer();
                }
            }
        }

        /**** Sale Coupon Apply ****/
        if (countItem === 1) {
            $(".ct_cart_pro_main_perent").hide();
        } else {
            const mainCartPrice = parseFloat($(cart).find(".theme-money-price").attr("data-price"));
            let couponHTML = "";

            if (mainCartPrice > 499) {
                $(".ct_cart_pro_main_perent").show();
                $(".ct_cart_cong .ct_cong_perc").text("10%");
                $(".ct_progress_discount").addClass("ct_cong_active");
                $(".ct_cart_pro_main").hide();
                $(".ct_cart_pro_bottom").html(
                    `Hurray! You’ve Unlocked <b>Free Delivery</b> On Online Orders`
                );
            } else {
                $(".ct_cart_pro_main_perent").show();
                const priceToShow = 500 - mainCartPrice;
                const sliderShow = (160 * priceToShow) / 500;

                $(".ct_cart_value_cercal").css("stroke-dashoffset", sliderShow);
                $(".ct_cart_pro_main").show();
                $(".ct_cart_pro_bottom").html(
                    `<div class="ct_cart_pro_bottom_inner"> Shop for <span class="ct_add_more">₹ ${priceToShow}</span> more to unlock <span class="ct_perc_off">Free Delivery</span></div>`
                );
                localStorage.setItem('confet_item', 1);
            }
        }

        // Update header cart count
        $('.ct_42876301344924').click();
        const parser = new DOMParser();
        const cartHTML = parser.parseFromString(cart, 'text/html');
        const cartCount = cartHTML.querySelector('.mm-ajaxcart-header span').innerText.match(/\((\d+)\)/)?.[1];
        document.querySelectorAll('.header-cart__count').forEach(elem => {
            elem.innerText = cartCount;
        });

        mmajaxcart.Giftcard();
         closeLoader();
  
 
if (typeof window.runFreeGiftFlow === "function") {
  if (!window.__FREE_GIFT_SELF_CHANGE) {
    // ONLY once after drawer opens / first render (not every render)
    if (!window.__FG_RAN_ON_DRAWER_OPEN) {
      window.__FG_RAN_ON_DRAWER_OPEN = true;
      setTimeout(() => window.runFreeGiftFlow("DrawerOpen"), 50);
      setTimeout(() => { window.__FG_RAN_ON_DRAWER_OPEN = false; }, 2000);
    }
  }
}


        

    }).fail(function() {
        closeLoader();
    });
  },

  AjaxcartChangeHandler: function(data) {

      var data = data;
      showLoader();
      $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: data,
          success: function(cart) {
                
              var cart_data = cart;
              var return_value = false;

              jQuery.each(cart_data.items_removed, function(i, c_val) {
                  var prod_id = c_val.product_id;
                  var get_ct_data = localStorage.getItem('ct_id');
                  var s_result = jQuery.parseJSON(get_ct_data);
                  $.each(s_result, function(i, val) {

                      if (prod_id == val.product_id) {
                          get_new_data_request = true;
                          var sku_val = "SKU "+c_val.sku;
                        //  var index = s_result.indexOf(val.c_id); //get index 
                          var index = s_result.findIndex(item => item.c_id === val.c_id);

                          s_result.splice(index, 1); //remove it
                        var attr_data_cart=JSON.stringify(s_result)
                          localStorage.setItem('ct_id', JSON.stringify(s_result)); //set again

                          if (typeof cart_data.note != "undefined") {
                              var data = cart_data.note;
                              var data_local = data;
                          } else {
                              var data_local = "";
                          }

                          var data_gift = data_local ? data_local : "";
                          var arr = data_gift.split('/');
                          var t="";
                            $.each(arr, function(i, val) {
                                var match_text="";
                                var innr = val.split('-');
                                $.each(innr, function(i1, val1) {
                                    match_text=val1
                                    return false;
                                })
                                if(match_text == sku_val)
                                {
                                  t= data_gift.replace(val, '');
                                  setTimeout(function() {

                                      $.post('/cart/update.js', {
                                              note: t,
                                              'attributes': {
                                                '_gift_wrap': attr_data_cart
                                              }
                                        
                                          })
                                          .done(function(t) {})
                                  }, 200);
                                  return false;
                                }
                                
                                  
                            })

                        
                        
                          // let data_gift = data_local ? JSON.parse(data_local) : [];
                          // $.each(data_gift, function(i, val) {
                          //     if (sku_val in val) {
                          //         var index = s_result.indexOf(sku_val);
                          //         data_gift.splice(index, 1); //remove it

                          //         var attribute = JSON.stringify(data_gift);

                          //         setTimeout(function() {

                          //             $.post('/cart/update.js', {
                          //                     note: attribute
                          //                 })
                          //                 .done(function(data) {})
                          //         }, 200);

                          //         return false;
                          //     }

                          // });


                          return_value = true;
                          return false;
                      }
                  });
                  if (return_value) {
                      return false;
                  }
              })

              mmajaxcart.AjaxcartRender();

              let CartCount = cart.item_count;
              if (CartCount <= 0) {
                  localStorage.removeItem("ct_id");
                  location.reload(true);
              }

              document.querySelectorAll('.header-cart__count').forEach((elem) => {
                  elem.innerText = cart.item_count;
              })
              $('.mm-cart-count').html(CartCount);
          },
          error: function() {
             closeLoader();
          }
      });

  },

  AjaxcartUpdateHandler: function(data) {

      let formData = {
          updates: data
      };

      showLoader();
      fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
          })
          .then(response => {
              return response.json();
          }).then(cart => {
              mmajaxcart.AjaxcartRender();

              let CartCount = cart.item_count;
              document.querySelectorAll('.header-cart__count').forEach((elem) => {
                  elem.innerText = cart.item_count;
              })
              $('.mm-cart-count').html(CartCount);
          })
          .catch((error) => {
              closeLoader();
          });

      // $.ajax({
      //   url: '/cart/update.js',
      //   dataType: 'json',
      //   cache: false,
      //   type: 'post',
      //   data: formData,
      //   success: function (cart) {
      //     mmajaxcart.AjaxcartRender();
      //     var CartCount = cart.item_count; 
      //     document.querySelector('.header-cart__count').innerText=cart.item_count;
      //     $('.mm-cart-count').html(CartCount);
      //   }
      // });

  },

  AjaxcartQuantityHandler: function() {

      function updateQuantity(elem) {
          var UpdatedQuantity = parseInt($(elem).val()),
              QuantityLine = parseInt($(elem).attr('data-line')),
              params = {
                  quantity: UpdatedQuantity,
                  line: QuantityLine
              };

          let parent = elem.closest("[data-custom-product]")
          let customProductQnty = UpdatedQuantity;
          if (elem.closest("[data-custom-product]").length) {
              document.querySelectorAll("[data-custom-product]").forEach((ele) => {
                  if (ele != parent[0]) {
                      customProductQnty = customProductQnty + parseInt(ele.dataset.quantity);
                  }
              })
              params = {};
              let parentKey = $(elem).attr('data-key')
              let addOnKey = document.querySelector("[data-addOnproduct]")

              params[parentKey] = UpdatedQuantity
              if (addOnKey) {
                  addOnKey = addOnKey.dataset.key
                  params[addOnKey] = customProductQnty
              };
              mmajaxcart.AjaxcartUpdateHandler(params);
          } else {
            
              mmajaxcart.AjaxcartChangeHandler(params);
          }

      }

      $(document).on('change', '.quantity-input', function() {
          updateQuantity($(this).parent().find('.quantity-input'))
      })
      $(document).on('click touchend', '.quantity-plus', function(e) {
          if (isSyntheticClickAfterTouch(this, e)) return;
          markTouchEvent(this, e);
          if (e && e.type === 'touchend') e.preventDefault();
          if ($(this).hasClass('quantity_disabled')) return;

          let q = $(this).parent().find('.quantity-input').val(),
              i = 1,
              p = parseInt(i),
              u = parseInt(q) + p;

          $(this).parent().find('.quantity-input').val(u)
          updateQuantity($(this).parent().find('.quantity-input'))
      })
      $(document).on('click touchend', '.quantity-minus', function(e) {
          if (isSyntheticClickAfterTouch(this, e)) return;
          markTouchEvent(this, e);
          if (e && e.type === 'touchend') e.preventDefault();

          let q = $(this).parent().find('.quantity-input').val(),
              i = 1,
              p = parseInt(i),
              u = parseInt(q) - p;


          // $(this).parent().find('.quantity-input').val(u).trigger('change');
          $(this).parent().find('.quantity-input').val(u)
          updateQuantity($(this).parent().find('.quantity-input'))

      })
  },
  AjaxcartRemoveItem: function() {
    $(document).on('click touchend', '.mm-ajaxcart-remove-item', function(e) {
        if (isSyntheticClickAfterTouch(this, e)) return;
        markTouchEvent(this, e);
        if (e && e.type === 'touchend') e.preventDefault();

        var RemoveLine = parseInt($(this).attr('data-line')),
            params = {
                quantity: 0,
                line: RemoveLine
            };

        let parent = this.closest("[data-custom-product]");

        if (parent && parent.hasAttribute('data-custom-product')) {
            let UpdatedQuantity = parseInt(parent.querySelector('input').value);
            let customProductQnty = 0;

            document.querySelectorAll("[data-custom-product]").forEach((ele) => {
                if (ele !== parent) {
                    customProductQnty += parseInt(ele.dataset.quantity);
                }
            });

            let parentKey = parent.dataset.key;
            let addOnKey = document.querySelector("[data-addOnproduct]");

            params[parentKey] = 0; // Update custom product quantity
            if (addOnKey) {
                params[addOnKey.dataset.key] = customProductQnty;
            }

            mmajaxcart.AjaxcartUpdateHandler(params);
            return;
        }
        mmajaxcart.AjaxcartChangeHandler(params);
    });
  },
  Ajaxupsell: function() {
      $(document).off('click.ctAjaxUpsell touchend.ctAjaxUpsell', '.mm-ajaxcart .add-to-cart, .ws-cart-items .add-to-cart');
      $(document).on('click.ctAjaxUpsell touchend.ctAjaxUpsell', '.mm-ajaxcart .add-to-cart, .ws-cart-items .add-to-cart', function(e) {
          if (isSyntheticClickAfterTouch(this, e)) return;
          markTouchEvent(this, e);
          if (e) e.preventDefault();

          var variantId = $(this).attr('data-variantids')
          var data = {
              id: variantId,
              quantity: 1
          };
          fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json'
              },
              method: 'POST'
          }).then(function(response) {
              return response.json();
          }).then(function(json) {
          
              mmajaxcart.AjaxcartOpen();
              mmajaxcart.AjaxcartRender();
          }).catch(function(err) {
              /* uh oh, we have error. */
              console.error(err)
          });
      });
  },
  Giftcard: function() {
      get_gifting_configuration();
  }
}


$(document).ready(function() {
    $(document).on('click', '.ct_dev_checkout', function(e) {
        var c_id = localStorage.getItem('ct_id');
        if (c_id != null) {
            let formData = {
                'items': [{
                    'id': 42876301344924,
                    'quantity': 1,
                    'properties': {
                        '_Gift_wrap': c_id
                    }
                }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    window.location = "/checkout"

                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            //jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[Gift_wrap]=" + c_id);
        }
        else
        {
            window.location = "/checkout"
        }

    })
    $(document).on('click', '.mm-ajaxcart-open', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartOpen();
        
        mmajaxcart.Giftcard();
    })
    $(document).on('click', '.mm-ajaxcart-close', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartClose();
    });
    // Keep the cart drawer open on outside clicks; close only via the explicit close button.
    $(document).on('click', '.mm-ajaxcart-overlay', function(e) {
        e.preventDefault();
    });

    $(document).on("click touchend", ".cart-coupons-card__view-all, [data-cart-coupons-close]", function (e) {
      if (isSyntheticClickAfterTouch(this, e)) return;
      markTouchEvent(this, e);
      if (e && e.type === "touchend") e.preventDefault();
      e.preventDefault();

      if ($(this).is("[data-cart-coupons-close]")) {
        closeCartCouponsPopup();
        return;
      }

      var cartRoot = document.querySelector(".cart-coupons-main");
      var cartValue = Number(cartRoot && cartRoot.getAttribute("data-cart-subtotal") || 0) / 100;
      var recommendedCoupon = String(cartRoot && cartRoot.dataset && cartRoot.dataset.ctRecommendedCoupon || "").trim().toUpperCase();
      var cartBand = String(cartRoot && cartRoot.dataset && cartRoot.dataset.ctCartBand || getCartCouponBand(cartValue)).trim();
      var viewAllSignature = [cartValue, recommendedCoupon, cartBand || getCartCouponBand(cartValue)].join("::");
      var viewAllNow = Date.now();
      var viewAllLastAt = Number(window.__ctViewAllCouponsClickedAt || 0);
      var isDuplicateViewAllClick = window.__ctViewAllCouponsClickedSignature === viewAllSignature && viewAllNow - viewAllLastAt < 1000;

      if (recommendedCoupon && !isDuplicateViewAllClick) {
        window.__ctViewAllCouponsClickedSignature = viewAllSignature;
        window.__ctViewAllCouponsClickedAt = viewAllNow;
        if (window.clevertap && clevertap.event && typeof clevertap.event.push === "function") {
        clevertap.event.push("View All Coupons Clicked", {
          cart_value: cartValue,
          recommended_coupon: recommendedCoupon,
          cart_band: cartBand || getCartCouponBand(cartValue)
        });
        }
      }

      openCartCouponsPopup();
    });

    $(document).on("click touchend", ".cart-coupons-card__apply, .cart-coupons-popup__apply", function (e) {
      if (isSyntheticClickAfterTouch(this, e)) return;
      markTouchEvent(this, e);
      if (e && e.type === "touchend") e.preventDefault();
      e.preventDefault();

      var couponAction = String($(this).data("coupon-action") || "apply").toLowerCase();
      var couponCode = $(this).data("coupon-code");
      if (couponAction === "remove") {
        updateCartCouponCode(couponCode, couponAction, this);
        return;
      }
      updateCartCouponCode(couponCode, couponAction, this);
    });

    $(document).on("click touchend", "[data-cart-coupons-input-apply]", function (e) {
      if (isSyntheticClickAfterTouch(this, e)) return;
      markTouchEvent(this, e);
      if (e && e.type === "touchend") e.preventDefault();
      e.preventDefault();

      var popup = getCartCouponsPopup();
      if (!popup) return;
      var input = popup.querySelector("[data-cart-coupons-input]");
      if (!input) return;

      var couponCode = String(input.value || "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
      if (couponCode.length < 3) return;

      updateCartCouponCode(couponCode, "apply", this);
    });

    $(document).on("keydown", "[data-cart-coupons-input]", function (e) {
      if (e.key !== "Enter") return;
      e.preventDefault();
      $(this).closest("[data-cart-coupons-popup]").find("[data-cart-coupons-input-apply]").trigger("click");
    });

    $(document).on("input", "[data-cart-coupons-input]", function () {
      syncCartCouponInputApplyState(this);
    });

    $(document).on("keydown", ".cart-coupons-popup__panel", function (e) {
      if (e.key === "Escape") {
        closeCartCouponsPopup();
      }
    });

    //mmajaxcart.AjaxcartRender();
    //  mmajaxcart.Giftcard();
    mmajaxcart.Ajaxupsell();
    mmajaxcart.AjaxcartRemoveItem();
    mmajaxcart.AjaxcartQuantityHandler();

    $(document).on('keyup', '#note', debounce(function() {
        var note = $(this).val();
        jQuery.post('/cart/update.js', "note=" + note);
    }, 500));


    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

  // Trust marker pass the event
 jQuery(document).on("click", ".Trust-mark-inner-cart .Trust-mark-box-cart", function() {
               
                var Tm_click={
                      "page":"Cart",
                     }
            clevertap.event.push("TM_click", Tm_click);
        });

       let customer_cartId = "";
    if (typeof __st.cid != "undefined") {
      customer_cartId = __st.cid;
    }
   
// Declare product_wish_data globally
let product_wish_data = null;
let currentCartItem = null;

$(document).on("click", ".cart_remove_btn", function () {

 
  currentCartItem = $(this).closest('.mm-ajaxcart-item');
  currentCartItem.addClass("active");
  // Ensure currentCartItem is valid
  if (!currentCartItem.length) {
    return;
  }

  // Get image and replace it in the popup
  const imgSrc = currentCartItem.find('.mm-ajaxcart-item-image img').attr('src');
  $('.pro_delete_detils_img img').attr('src', imgSrc);

  // Extract data attributes
  const product_id = currentCartItem.data("prod_id");
  const variant_id = currentCartItem.data("variant_id");
  const main_price = currentCartItem.attr("data_main_price");
  const sell_price = currentCartItem.attr("data_sell_price");
  const product_title = currentCartItem.data("prod-title");
  const product_type = currentCartItem.data("prod-type");
  const prod_sku= currentCartItem.data("sku");

  // Prepare product_wish_data
  product_wish_data = {
    groupId: product_id,
    name: product_title,
    price: sell_price,
    sellingPrice: main_price,
    image: imgSrc,
    sku:prod_sku,
    variantId: variant_id,
    customerEmail: "",
    accessToken: "",
    customerId: customer_cartId,
    registrationId: "",
    device: "WEB",
    version: "2.4",
    collectionName: product_type,
  };

  $('.cart_pro_delete').addClass('active');
  window.__CART_REMOVE_CONFIRM_OPEN = true;

  $(".pro_delete_bottom").attr("data-prod", JSON.stringify(product_wish_data));
});

$(document).on("click touchend", ".cart_wishlist_btn", async function (e) {
  if (isSyntheticClickAfterTouch(this, e)) return;
  markTouchEvent(this, e);
  if (e && e.type === "touchend") e.preventDefault();
  e.preventDefault();

  const $button = $(this);
  if ($button.data("processing")) return;
  $button.data("processing", true);

  const $cartItem = $(this).closest(".mm-ajaxcart-item");
  if (!$cartItem.length) {
    $button.data("processing", false);
    return;
  }

  const imgSrc = $cartItem.find(".mm-ajaxcart-item-image img").attr("src") || "";
  const product_id = $cartItem.data("prod_id");
  const variant_id = $cartItem.data("variant_id");
  const main_price = $cartItem.attr("data_main_price");
  const sell_price = $cartItem.attr("data_sell_price");
  const product_title = $cartItem.data("prod-title");
  const product_type = $cartItem.data("prod-type") || $cartItem.data("prod-metafiled-type") || "";
  const prod_sku = $cartItem.data("sku");
  const variantKey = String(variant_id || "");
  let localProductData = localStorage.getItem("local_wish_prod_data");
  localProductData = localProductData ? JSON.parse(localProductData) : [];
  const alreadyWishlisted = Array.isArray(localProductData) && localProductData.map(String).includes(variantKey);

  const removeCartItem = () => {
    const $removeBtn = $cartItem.find(".mm-ajaxcart-remove-item").first();
    if ($removeBtn.length) {
      $removeBtn.trigger("click");
      return;
    }

    const lineToRemove = parseInt($cartItem.attr("data-line"), 10);
    if (!Number.isNaN(lineToRemove)) {
      mmajaxcart.AjaxcartChangeHandler({ quantity: 0, line: lineToRemove });
    }
  };

  if (alreadyWishlisted) {
    showLoader();
    removeCartItem();
    return;
  }

  const wishlistPayload = {
    groupId: product_id,
    name: product_title,
    price: sell_price,
    sellingPrice: main_price,
    image: imgSrc,
    sku: prod_sku,
    variantId: variant_id,
    customerEmail: "",
    accessToken: "",
    customerId: customer_cartId,
    registrationId: typeof uniqueId !== "undefined" ? uniqueId : "",
    device: "WEB",
    version: "2.4",
    collectionName: product_type || "Wishlist",
  };

  try {
    showLoader();

    const added = await addProductToCollection(wishlistPayload);

    if (added && added[0]) {
      clevertap.event.push("Move To Wishlist", {
        sku: prod_sku,
      });

      sessionStorage.setItem("wishlistFetched", "false");
      if (!localProductData.includes(String(variant_id))) {
        localProductData.push(String(variant_id));
        localStorage.setItem("local_wish_prod_data", JSON.stringify(localProductData));
      }

      removeCartItem();
    } else {
      if (typeof closeLoader === "function") {
        closeLoader();
      }
      $button.data("processing", false);
    }
  } catch (error) {
    console.error("Error moving cart item to wishlist:", error);
    if (typeof closeLoader === "function") {
      closeLoader();
    }
    $button.data("processing", false);
  }
});

$(document).on("click", ".pro_delete_remove", function (e) {
    e.preventDefault();

    if (!currentCartItem || currentCartItem.length === 0) {
        return;
    }

    let lineToRemove = parseInt(currentCartItem.attr("data-line"), 10);
    let variantId = currentCartItem.data("variant_id");
    let variantRemove = document.querySelectorAll(".mm-ajaxcart-remove-item");

    showLoader();
    var prod_remove_sku = currentCartItem.data("sku");
    var wishlist_remove_item = {
        "sku": prod_remove_sku,
    };

    let removed = false;
    variantRemove.forEach((el) => {
        if (removed) return;
        let line = parseInt(el.getAttribute('data-line'), 10);
        let variantIdCart = parseInt(el.getAttribute('data-variant_id'));

        const shouldMatch = !Number.isNaN(lineToRemove)
          ? line === lineToRemove
          : variantIdCart === variantId;

        if (shouldMatch) {
            removed = true;
            clevertap.event.push("Wishlist Item Removed", wishlist_remove_item);
            $(el).trigger('click');
            $('.cart_pro_delete').removeClass('active');
             window.__CART_REMOVE_CONFIRM_OPEN = false;
        }
    });

    if (!removed && !Number.isNaN(lineToRemove)) {
      mmajaxcart.AjaxcartChangeHandler({ quantity: 0, line: lineToRemove });
      $('.cart_pro_delete').removeClass('active');
      window.__CART_REMOVE_CONFIRM_OPEN = false;
    }
});

$(document).on("click",".cart_pro_delete_close", function () {
  $('.cart_pro_delete').removeClass('active');
   window.__CART_REMOVE_CONFIRM_OPEN = false;
});

$(document).on("click", ".cart_pro_delete.active .pro_add_wishlist", async function (e) {
  e.preventDefault();
  showLoader();
  const product_wish_data_str = $(".pro_delete_bottom").attr("data-prod");

  // Ensure product_wish_data is valid
  if (!product_wish_data_str) {
    alert("Please select a product first.");
    return;
  }

  try {
    const prod_json = JSON.parse(product_wish_data_str);
    prod_json.registrationId = uniqueId;

    const added = await addProductToCollection(prod_json);
    
    
    if (added[1] !== "") {
      var p_sku=prod_json.sku;
       var move_to_wishlist={
                      "sku":p_sku
                     }
            clevertap.event.push("Move To Wishlist", move_to_wishlist);
        
      jQuery(".cart_pro_delete").removeClass("active");
       $(".cart_moved_wishlist").show();

      setTimeout(() => {
        $(".cart_moved_wishlist").hide();
        if (!currentCartItem || currentCartItem.length === 0) {
            return;
        }

        let lineToRemove = parseInt(currentCartItem.attr("data-line"), 10);
        let variantId = currentCartItem.data("variant_id");
        let variantRemove = document.querySelectorAll(".mm-ajaxcart-remove-item");
        let removed = false;
        variantRemove.forEach((el) => {
            if (removed) return;
            let line = parseInt(el.getAttribute('data-line'), 10);
            let variantIdCart = parseInt(el.getAttribute('data-variant_id'));

            const shouldMatch = !Number.isNaN(lineToRemove)
              ? line === lineToRemove
              : variantIdCart === variantId;

            if (shouldMatch) {
                removed = true;
                $(el).trigger('click');
                $('.cart_pro_delete').removeClass('active');
                 window.__CART_REMOVE_CONFIRM_OPEN = false;
            }
        });
        if (!removed && !Number.isNaN(lineToRemove)) {
          mmajaxcart.AjaxcartChangeHandler({ quantity: 0, line: lineToRemove });
          $('.cart_pro_delete').removeClass('active');
          window.__CART_REMOVE_CONFIRM_OPEN = false;
        }
      }, 2000); 
      sessionStorage.setItem("wishlistFetched", "false");
    }
  } catch (error) {
    console.error("Error processing wishlist action:", error);
  }
});

})

async function addProductToCollection(data) {

  try {
    const response = await $.ajax({
      url: `${window.apiUrl}/wishlist/collection-item`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(data),
    });

    let localProductData = localStorage.getItem("local_wish_prod_data");
    localProductData = localProductData ? JSON.parse(localProductData) : [];
    if (!localProductData.includes(String(data.variantId))) {
      localProductData.push(String(data.variantId));
      localStorage.setItem("local_wish_prod_data", JSON.stringify(localProductData));
    }
    sessionStorage.setItem("wishlistFetched", "false");

    return [response.success, data.groupId];
  } catch (error) {
    return [false, null];
  }
}

// This will apply the debounce effect on the keyup event
// And it only fires 500ms or half a second after the user stopped typing


// Wishlist modals
async function fetchWishlist() {
    let customerId = "";
    if (typeof __st.cid != "undefined") {
        customerId = __st.cid;
    }
    const url = `${window.apiUrl}/customer/wishlist?registrationId=${uniqueId}&customerId=${customerId}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        // Log raw response
        const rawResponse = await response.text();

        let data;
        try {
            data = JSON.parse(rawResponse);

            // Store only the first 7 items
            if (Array.isArray(data)) {
                data = data.slice(0, 7);
            }
        } catch (error) {
            data = rawResponse;
        }

        sessionStorage.setItem("wishlistData", JSON.stringify(data));
        sessionStorage.setItem("wishlistFetched", "true");

    } catch (error) {
        console.error("Request Failed:", error);
    }
}

async function fetchDeliveryDate(pickupPinCode, dropPinCode, isPinCheck) {
  if (pickupPinCode && dropPinCode) {
    const url = `${window.apiUrl}/callback/expected-delivery-date`;
    const data = {
      pickupPinCode: pickupPinCode,
      dropPinCode: dropPinCode,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.deliveryBy) {
        syncCartDeliveryDates(result.deliveryBy);

        sessionStorage.setItem("eddPinCheckCart", result.deliveryBy);

        if (isPinCheck) {
          renderPreEddCheckMessage(result.deliveryBy);
        }
      } else {
        syncCartDeliveryDates("");
      }
    } catch (error) {
      syncCartDeliveryDates("");
    }
  }
}


// Run after DOM loads
document.addEventListener("DOMContentLoaded", function () {
  const apiCalled = sessionStorage.getItem("wishlistFetched");
  const wishlistData = JSON.parse(sessionStorage.getItem("wishlistData") || "[]");
  const isWishlistEmpty = !Array.isArray(wishlistData) || wishlistData.length === 0;

  // Call API if not called or wishlist data is empty
  if (apiCalled !== "true" || isWishlistEmpty) {
    fetchWishlist();
  }
});


async function displayWishlist(data) {
    const cartItemsContainer = document.querySelectorAll(".ws-cart-items");
    if (cartItemsContainer) {
      const processedData = await getProductData(data, true);
      cartItemsContainer.forEach((e) => {
        e.innerHTML = processedData;
      });
    }
}
